import {
  IDisplayedSlice,
  IRetentionAverageReturnCell,
  IRetentionReturnCell,
} from '../../interfaces';
import { useMemo } from 'react';
import { OVERALL_SLICE_KEY } from '../../constants/utils';
import { assertNotNil, isNotNil } from '../../../../utils/types';
import { MaybeNil } from '../../../../utils/interfaces';
import { getIntervalDisplay } from '../../../../utils/redux/transformRetentionData';

export const RetentionTooltipHeader = ({
  sliceKey,
  displayedSlices,
  returnCell,
}: {
  sliceKey: string;
  displayedSlices: IDisplayedSlice[];
  returnCell: IRetentionReturnCell | IRetentionAverageReturnCell;
}) => {
  const headerString = useMemo(() => {
    let sliceName: string | null = null;
    if (sliceKey !== OVERALL_SLICE_KEY) {
      const slice = displayedSlices.find((ds) => ds.key === sliceKey);
      assertNotNil(slice);
      sliceName = slice.name;
    }

    let headerParts: MaybeNil<string>[];
    if (returnCell.__typename === 'IRetentionReturnCell') {
      const intervalDisplay = getIntervalDisplay(returnCell.startInterval);
      headerParts = ['Cohort', intervalDisplay, sliceName];
    } else {
      headerParts = ['Average', sliceName];
    }

    return headerParts.filter(isNotNil).join(' - ');
  }, [displayedSlices, returnCell, sliceKey]);
  return <>{headerString}</>;
};
